import Typography, { CustomTypographyProps } from "./Typography";
import { compose, withHooks, withTranslation } from "enhancers";
import { Trans, TransProps } from "react-i18next";

type TProps = CustomTypographyProps &
  TransProps<string> & {
    children: string;
  };

const T = ({ t, children, ...rest }: TProps) => (
  <Trans i18nKey={children} parent={Typography} {...(rest as any)} />
);

const enhancer = compose(
  withTranslation(),
  withHooks((props: any, hooks: any) => {
    return { ...props };
  })
);

export default enhancer(T);
